import React from "react";
import { Menu, MenuItem, IconButton, ListItemIcon, ListItemText, Tooltip } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";

const RowContextMenu = ({ row, actions }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleOpen = (event) => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };

    const handleAction = (action) => {
        action.onClick && action.onClick(row)
        handleClose();
    };

    const availableActions = actions.filter(a=>a.visible||a.visible===undefined);

    if (availableActions.length === 1) {
        return (
            <Tooltip title={availableActions[0].name}>
                <IconButton onClick={() => handleAction(availableActions[0])} color="primary">
                    {availableActions[0].icon}
                </IconButton>
            </Tooltip>
        )
    }


  return (
    <div>
      <IconButton onClick={handleOpen} color="secondary">
        <MoreVertIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {actions && availableActions.map((action, index) => (
           <MenuItem key={index} onClick={() => handleAction(action)}>
            <ListItemIcon>
                {action.icon}
            </ListItemIcon>
            <ListItemText>{action.name}</ListItemText>
          </MenuItem>
        ))}

      </Menu>
    </div>
  );
};

export default RowContextMenu;